const getDateValue = (value: Date | null | undefined, convertToDate = false): Date => {
  if (convertToDate) return value ? new Date(value) : new Date();

  return value ?? ('' as unknown as Date);
};

export default getDateValue;
